module.exports = __webpack_public_path__ + "img/yundong.b31f0e81.png";